export const PriceGuidanceTooltipText =
  'We calculate average prices based on similar flights ' +
  '(same locations, booking window, travel type, cabin class) ' +
  'over the past 60 days.'
